var map = {
	"./apple-touch-icon.png": 172,
	"./chicken-banner.jpg": 456,
	"./favicon-96x96.png": 635,
	"./favicon.svg": 529,
	"./ncpa-logo.png": 842,
	"./straw-texture-v2.svg": 87,
	"./text-logo.png": 489,
	"./web-app-manifest-192x192.png": 541,
	"./web-app-manifest-512x512.png": 245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;